// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1xUyl","options":"AnswerScale_options__2vZt8","selected":"AnswerScale_selected__3rGMa"};